import {UIUtilsEjsVariables} from '../../../../../shared/scripts/UIUtilsEjsVariables'

export class UIDLoadingScreen {
    private readonly loadingContainer: HTMLDivElement
    private readonly loadingSpinner: HTMLDivElement

    constructor() {
        if(!UIUtilsEjsVariables.isUserOnDiscord) return
        this.loadingContainer = document.getElementById('loading-screen') as HTMLDivElement
        this.loadingSpinner = document.getElementById('loading-screen-spinner-container') as HTMLDivElement
    }

    showBackground() {
        this.setAnimationInitialState()
    }

    hideBackground() {
        this.setAnimationFinalState()
    }

    hideSpinner() {
        this.loadingSpinner.style.visibility = 'hidden'
    }

    showSpinner() {
        this.loadingSpinner.style.visibility = 'visible'
    }

    private setAnimationInitialState() {
        this.loadingContainer.style.display = 'inherit'
        this.loadingContainer.style.visibility = 'visible'
        this.loadingContainer.style.opacity = '1'
    }

    private setAnimationFinalState() {
        this.loadingContainer.style.opacity = '0'
        this.loadingContainer.style.visibility = 'hidden'
        this.hideDisplayAfterAnimationComplete()
    }

    private hideDisplayAfterAnimationComplete() {
        const animationCompletionDelay = 1000 // Milliseconds
        setTimeout(() => {
            this.loadingContainer.style.display = 'none'
        }, animationCompletionDelay)
    }
}
